<template>
  <div class="list-module">
    <div class="form-row">
      <div class="form-label">焦点标题：</div>
      <div class="form-content">
        <a-select v-model="value.focusTitleType" class="type-select" :options="typeOptions" />
        <a-input
          v-if="value.focusTitleType === 1"
          v-model="value.focusTitle"
          class="title-input"
          placeholder="请输入"
          allow-clear
        />
        <div v-else class="upload-wrap">
          <a-upload
            :action="uploadFileUrl"
            :accept="acceptTypes"
            :file-list="focusTitleFileList"
            :before-upload="beforeUploadImage"
            @change="info => onFocusImageChange('focusTitle', info)"
          >
            <a-button icon="upload">上传文件</a-button>
          </a-upload>
          <div class="upload-tip">支持扩展名：.png .jpg...；图片最佳尺寸：宽度不限 * 70px</div>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-label">焦点副标题：</div>
      <div class="form-content">
        <a-select v-model="value.focusSubTitleType" class="type-select" :options="typeOptions" />
        <a-input
          v-if="value.focusSubTitleType === 1"
          v-model="value.focusSubTitle"
          class="title-input"
          placeholder="请输入"
          allow-clear
        />
        <div v-else class="upload-wrap">
          <a-upload
            :action="uploadFileUrl"
            :accept="acceptTypes"
            :file-list="focusSubTitleFileList"
            :before-upload="beforeUploadImage"
            @change="info => onFocusImageChange('focusSubTitle', info)"
          >
            <a-button icon="upload">上传文件</a-button>
          </a-upload>
          <div class="upload-tip">支持扩展名：.png .jpg...；图片最佳尺寸：宽度不限 * 70px</div>
        </div>
      </div>
    </div>

    <div class="section-title">选择商品列表样式</div>
    <div class="style-grid">
      <div
        v-for="style in listStyles"
        :key="style.value"
        class="style-item"
        :class="{ active: value.switchStyleType === style.value }"
        @click="value.switchStyleType = style.value"
      >
        <img class="style-preview-img" :src="style.image" :alt="style.label">
      </div>
    </div>

    <!-- 酒店商品列表默认值设置（静态页，选项后续对接接口） -->
    <div class="section-title hotel-default-title">酒店商品列表默认值设置</div>
    <div class="hotel-default">
      <div class="form-row">
        <div class="form-label form-label--wide">默认城市：</div>
        <div class="form-content">
          <a-input
            v-model="value.defaultCity"
            class="title-input"
            placeholder="请输入"
            allow-clear
          />
        </div>
      </div>

      <div class="form-row">
        <div class="form-label form-label--wide">是否允许按定位刷新城市：</div>
        <div class="form-content form-content--center">
          <a-radio-group v-model="value.allowLocateCity">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
        </div>
      </div>

      <div class="form-row form-row--block">
        <div class="form-label form-label--wide">其他默认项：</div>
        <div class="form-content hotel-default__filters">
          <div
            v-for="group in filterGroups"
            :key="group.key"
            class="filter-row"
          >
            <span class="filter-row__label">{{ group.label }}：</span>
            <a-checkbox-group v-model="value[group.field]" :options="group.options" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const LIST_STYLE_IMAGE = ''
const LIST_STYLE_IMAGE2 = 'https://imgbtest.woyoubooking.com/test/base/5b3a661ebaf84870a8e85381b9f2b9ef.png'
const LIST_STYLE_IMAGE3 = ''
const LIST_STYLE_IMAGE4 = ''

export default {
  name: 'ActivityListModule',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      uploadFileUrl: this.getUploadFileUrl(),
      acceptTypes: '.png,.jpg,.jpeg',
      typeOptions: [
        { label: '文字', value: 1 },
        { label: '图片', value: 2 }
      ],
      focusTitleFileList: [],
      focusSubTitleFileList: [],
      listStyles: [
        { value: 1, label: '商品列表样式1', image: LIST_STYLE_IMAGE },
        { value: 2, label: '商品列表样式2', image: LIST_STYLE_IMAGE2 },
        { value: 3, label: '商品列表样式3', image: LIST_STYLE_IMAGE3 },
        { value: 4, label: '商品列表样式4', image: LIST_STYLE_IMAGE4 }
      ],
      // 静态占位选项，后续替换为接口数据
      filterGroups: [
        {
          key: 'star',
          label: '星级',
          field: 'defaultStarIds',
          options: [
            { label: '2钻/星及以下', value: '6' },
            { label: '3钻/星', value: '4,5' },
            { label: '4钻/星', value: '2,3' },
            { label: '5钻/星', value: '1' },
            { label: '金钻酒店', value: '0' }
          ]
        },
        {
          key: 'brand',
          label: '品牌',
          field: 'defaultBrandIds',
          options: [
            { label: '维也纳酒店', value: '897647' },
            { label: '全季', value: '23828' },
            { label: '汉庭', value: '697592' },
            { label: '如家', value: '28349' },
            { label: '7天', value: '23775' },
            { label: '锦江之星', value: '1099766' },
            { label: '桔子', value: '660099' },
            { label: '希尔顿欢朋', value: '2882775' },
            { label: '如家精选', value: '2879688' },
            { label: '皇冠假日', value: '1263157' },
            { label: '希尔顿', value: '501033' },
            { label: '华美达', value: '274565' },
            { label: '希尔顿花园', value: '1805279' },
            { label: '万豪', value: '102382' }
          ]
        },
        {
          key: 'theme',
          label: '主题',
          field: 'defaultThemeIds',
          options: [
            { label: '购物便捷', value: '0' },
            { label: '休闲情调', value: '3' },
            { label: '交通便利', value: '4' },
            { label: '商旅之家', value: '6' },
            { label: '安静优雅', value: '9' },
            { label: '温泉酒店', value: '17' }
          ]
        },
        {
          key: 'type',
          label: '类型',
          field: 'defaultTypeIds',
          options: [
            { label: '经济', value: '0' },
            { label: '快捷', value: '1' },
            { label: '商务', value: '2' },
            { label: '主题', value: '3' },
            { label: '公寓', value: '5' },
            { label: '度假', value: '12' },
            { label: '别墅', value: '13' }
          ]
        }
      ]
    }
  },
  created () {
    if (this.value.switchStyleType == null) {
      this.$set(this.value, 'switchStyleType', 1)
    }
    if (this.value.focusTitleType == null) {
      this.$set(this.value, 'focusTitleType', 1)
    }
    if (this.value.focusTitle == null) {
      this.$set(this.value, 'focusTitle', '')
    }
    if (this.value.focusSubTitleType == null) {
      this.$set(this.value, 'focusSubTitleType', 1)
    }
    if (this.value.focusSubTitle == null) {
      this.$set(this.value, 'focusSubTitle', '')
    }
    this.ensureHotelDefaultFields()
    // 编辑回填：图片类型标题回显上传列表
    if (this.value.focusTitleType === 2 && this.value.focusTitle) {
      this.focusTitleFileList = [{
        uid: 'list_focus_title',
        name: 'image',
        status: 'done',
        url: this.value.focusTitle
      }]
    }
    if (this.value.focusSubTitleType === 2 && this.value.focusSubTitle) {
      this.focusSubTitleFileList = [{
        uid: 'list_focus_sub_title',
        name: 'image',
        status: 'done',
        url: this.value.focusSubTitle
      }]
    }
  },
  methods: {
    ensureHotelDefaultFields () {
      if (this.value.defaultCity == null) {
        this.$set(this.value, 'defaultCity', '')
      }
      if (this.value.allowLocateCity == null) {
        this.$set(this.value, 'allowLocateCity', 0)
      }
      ;['defaultStarIds', 'defaultBrandIds', 'defaultThemeIds', 'defaultTypeIds'].forEach((field) => {
        if (!Array.isArray(this.value[field])) {
          this.$set(this.value, field, [])
        }
      })
    },
    getUploadFileUrl () {
      const appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    getUploadResponseUrl (file) {
      if (!file) return ''
      if (file.url) return file.url
      const response = file.response
      if (!response) return ''
      if (typeof response === 'string') return response
      if (typeof response.data === 'string') return response.data
      if (response.data && typeof response.data.url === 'string') return response.data.url
      if (typeof response.url === 'string') return response.url
      return ''
    },
    beforeUploadImage (file) {
      const fileName = file.name || ''
      const suffix = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
      const isAccept = ['.png', '.jpg', '.jpeg'].indexOf(suffix) > -1
      if (!isAccept) {
        this.$message.error('上传文件只能是 png、jpg、jpeg 格式')
        return false
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },
    normalizeFileList (fileList) {
      return fileList.slice(-1).map(file => {
        const url = this.getUploadResponseUrl(file)
        if (url) {
          file.url = url
        }
        return file
      })
    },
    onFocusImageChange (field, info) {
      const fileList = this.normalizeFileList([...info.fileList])
      const url = this.getUploadResponseUrl(fileList[0]) || ''
      if (field === 'focusTitle') {
        this.focusTitleFileList = fileList
        this.value.focusTitle = url
      } else {
        this.focusSubTitleFileList = fileList
        this.value.focusSubTitle = url
      }
      if (info.file.status === 'done') {
        this.$message.success('上传成功')
      } else if (info.file.status === 'error') {
        this.$message.error('上传失败')
      }
    }
  }
}
</script>

<style scoped lang="less">
.list-module {
  flex: 1;
  min-width: 0;
  max-height: calc(100vh - 260px);
  overflow-x: hidden;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.form-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
}

.form-label {
  width: 100px;
  line-height: 32px;
  text-align: left;
  color: #333;
  flex-shrink: 0;
}

.form-content {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
}

.type-select {
  width: 100px;
  flex-shrink: 0;
}

.title-input {
  width: 320px;
}

.upload-wrap {
  .upload-tip {
    margin-top: 4px;
    color: #999;
    font-size: 12px;
  }
}

.section-title {
  margin: 8px 0 12px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.style-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  flex: 1;
  align-content: start;
}

.style-item {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 4px;
  // background: #1a120b;

  &.active {
    border-color: #1890ff;
  }
}

.style-preview-img {
  display: block;
  width: 100%;
  height: auto;
  vertical-align: top;
}

.hotel-default-title {
  margin-top: 24px;
}

.hotel-default {
  .form-label--wide {
    width: 180px;
  }

  .form-content--center {
    align-items: center;
    min-height: 32px;
  }

  .form-row--block {
    flex-direction: column;
    align-items: stretch;

    .form-label--wide {
      width: auto;
      text-align: left;
      margin-bottom: 8px;
    }

    .hotel-default__filters {
      padding-left: 0;
    }
  }

  &__filters {
    flex-direction: column;
    gap: 12px;
  }
}

.filter-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 32px;

  &__label {
    width: 48px;
    flex-shrink: 0;
    color: #333;
    line-height: 22px;
  }
}
</style>
